import { useEffect, useState } from 'react';
import JlrButton from '../JlrButton/JlrButton';
import { connect } from 'react-redux';
import ConfirmMarkCompleteDialog from '../ConfirmMarkCompleteDialog/ConfirmMarkCompleteDialog';

const mapStateToProps = (state) => {
	return {
		operations: state.operations,
		themeMode: state.theme.themeMode,
		plantName: state.user.plant,
	};
};

const MarkComplete = ({
	operations,
	onMarkComplete,
	onNextOperation,
	handleButtonClick, // Support legacy prop
	themeMode,
	plantName,
}) => {
	const [isLastOperation, setIsLastOperation] = useState(false);
	const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
	const { allowedOperations, currentOperation } = operations;

	useEffect(() => {
		const isLast =
			currentOperation === allowedOperations[allowedOperations.length - 1];
		setIsLastOperation(isLast);
	}, [currentOperation, allowedOperations]);

	const handleClick = () => {
		if (isLastOperation) {
			setIsConfirmDialogOpen(true);
		} else if (typeof onNextOperation === 'function') {
			onNextOperation();
		}
	};

	const handleConfirm = () => {
		setIsConfirmDialogOpen(false);
		const callback = onMarkComplete || handleButtonClick;
		if (callback) {
			callback();
		}
	};

	return (
		<>
			<JlrButton
				variant="success"
				size="medium"
				onClick={handleClick}
				themeMode={themeMode}
				plantName={plantName}
			>
				{isLastOperation ? 'Mark Complete' : 'Next Operation'}
			</JlrButton>

			<ConfirmMarkCompleteDialog
				open={isConfirmDialogOpen}
				onClose={() => setIsConfirmDialogOpen(false)}
				onConfirm={handleConfirm}
			/>
		</>
	);
};

export default connect(mapStateToProps)(MarkComplete);
